import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSpotify,
  faInstagram,
  faFacebook,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import "./mConnect.css";

const SOCIAL_LINKS = [
  {
    icon: faSpotify,
    label: "Spotify",
    url: "https://open.spotify.com/artist/2nKkYeW42RSx0jPNKQZ64U?si=e4FrAbw0SGaWav4Jg5SaEA",
  },
  {
    icon: faInstagram,
    label: "Instagram",
    url: "https://www.instagram.com/dodsegoband/",
  },
  {
    icon: faFacebook,
    label: "Facebook",
    url: "https://facebook.com/dodsegoband",
  },
  {
    icon: faYoutube,
    label: "YouTube",
    url: "https://www.youtube.com/@Dodsego",
  },
  {
    icon: faEnvelope,
    label: "Email",
    url: "mailto:dodsego@gmail.com",
  },
];

const MConnect = () => (
  <div className="mconnect-container" id="connect">
    <section className="mconnect-card">
      <header className="mconnect-header">
        <h1>Connect with DØDSEGO</h1>
        <p>
          Follow the collective for releases, live happenings, and visual experiments. Reach out for
          bookings or collaborations.
        </p>
      </header>

      <div className="mconnect-social" aria-label="Social media">
        {SOCIAL_LINKS.map(({ icon, label, url }) => (
          <a key={label} className="mconnect-link" href={url} target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={icon} />
            <span className="sr-only">{label}</span>
          </a>
        ))}
      </div>

      <div className="mconnect-contact">
        <span className="mconnect-contact-label">Booking & press</span>
        <a className="mconnect-email" href="mailto:dodsego@gmail.com">
          dodsego@gmail.com
        </a>
      </div>
    </section>
  </div>
);

export default MConnect;